// extracted by mini-css-extract-plugin
export default {"TypeConsultation":"EditionTypeConsultation_TypeConsultation__NDDyb"};